import { generateUuid } from 'zoomforth_zfutils/unique_identifiers.js';

var windowSessionId = undefined;

export const getWindowSessionId = ()=> {
  if (!windowSessionId) {
    windowSessionId = generateUuid();
  }
  return windowSessionId;
}